import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function EmployeeLogin() {
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (pin.length < 4) {
      toast.error("Bitte geben Sie einen gültigen PIN-Code ein");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/employee-login`, { pin });
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      toast.success(`Willkommen, ${response.data.user.name}!`);
      navigate("/employee/clock");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Ungültiger PIN-Code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Button
          variant="ghost"
          onClick={() => navigate("/")}
          className="mb-6 rounded-full"
          data-testid="back-button"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück
        </Button>

        <Card className="shadow-2xl border-0 rounded-3xl">
          <CardHeader className="text-center pb-4">
            <CardTitle className="text-3xl font-bold" style={{ fontFamily: 'Work Sans, sans-serif' }}>
              Mitarbeiter Login
            </CardTitle>
            <CardDescription className="text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
              Geben Sie Ihren PIN-Code ein
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-6">
              <div>
                <Input
                  type="password"
                  inputMode="numeric"
                  placeholder="PIN-Code eingeben"
                  value={pin}
                  onChange={(e) => setPin(e.target.value)}
                  className="text-center text-2xl h-16 rounded-2xl"
                  maxLength={10}
                  data-testid="pin-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full h-14 text-lg rounded-full bg-blue-600 hover:bg-blue-700 transition-colors duration-200"
                disabled={loading}
                data-testid="login-submit-button"
              >
                {loading ? "Wird geladen..." : "Anmelden"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
